import "./DoceDeLeiteMobile.css";
import logo from "../../../assets/doce-de-leite/logo-doce-de-leite.png";
import produto from "../../../assets/doce-de-leite/produto-doce-de-leite.png";
export default function DoceDeLeite() {
return(
    <div className="container-doce-de-leite-mobile">
    <div className="title-content-doce-de-leite-mobile">
        <div className="title-logo-doce-de-leite-mobile">
        <p className="title-doce-de-leite-mobile">Doce de Leite <br/> Tradicional</p>
        <img src={logo} className="logo-doce-de-leite-mobile" />
        </div>
        <div className="subtitle-content-doce-de-leite-mobile">
        <p className="subtitle-doce-de-leite-mobile">Receita familiar de tradição mineira!</p>
        </div>
    </div> 

    <div className="about-doce-de-leite-mobile">
         <div className="about-title-cointainer-doce-de-leite-mobile"> 
        <p className="about-title-doce-de-leite-mobile">O Doce de Leite <br/> Poços de Caldas</p>
        </div>
        <div className="about-text-container-doce-de-leite-mobile"> 
        <p className="about-text-doce-de-leite-mobile">é um produto superior<br/>aos similares no mercado, produzido de uma maneira diferenciada, para atingir<br/>um alto padrão de sabor e <br/>agradar aos paladares<br/>mais refinados. </p> 
        </div> 
        <div className="line-container-doce-de-leite-mobile"></div>
        <p className="about-text3-doce-de-leite-mobile">Desde 1949</p>  
        <div className="line-container-doce-de-leite-mobile"></div>    
        </div> 
        <img src={produto}  className="produto-doce-de-leite-mobile"/>  

    </div>
)
}